import React from "react";
import PageLayout from "./PageLayout";
import WorkSection from "./WorkSection";
import ReviewsSection from "./ReviewsSection";
import WorkStatsBanner from "./WorkStatsBanner";
import usePageMeta from "../hooks/usePageMeta";
import useScrollToHash from "../hooks/useScrollToHash";

const NosotrosPage = () => {
  usePageMeta({
    title: "Nosotros | RGST",
    description:
      "Trabajos realizados, reseñas de clientes y contacto directo con RG Servicio Técnico.",
    canonical: "https://rgserviciotecnico.com/nosotros",
  });

  useScrollToHash({ defaultId: "trabajos" });

  return (
    <PageLayout className="bg-background">
      <WorkSection />
      <ReviewsSection />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-24">
        <WorkStatsBanner />
      </div>
    </PageLayout>
  );
};

export default NosotrosPage;
